import { FastshiftChampionCard } from '../../cards/fastshift-champion-card';
import { FastshiftTeamCard } from '../../cards/fastshift-team-card';
import { SupportEngineersCard } from '../../cards/support-engineers-card';
import { RawRelationships } from '../../types';
import { findChampion, mapRelationships, filterEngineers } from '../../utils';
import { BaseRelationshipsSection } from '../base-relationships-section';

export const PartnerRelationshipsSection = ({
	relationships,
}: {
	relationships: RawRelationships;
}) => {
	const champion = findChampion(relationships);
	const relationshipMapping = mapRelationships(relationships);
	const engineers = filterEngineers(relationships);

	return (
		<BaseRelationshipsSection>
			{champion && <FastshiftChampionCard champion={champion} />}
			<FastshiftTeamCard relationships={relationshipMapping} />
			<SupportEngineersCard engineers={engineers} />
		</BaseRelationshipsSection>
	);
};
